export interface IBoxShadow {
  interface: string;
}

export const boxShadow: IBoxShadow = {
  interface: "0 3px 12px rgba(0,0,0,0.06)",
};
